var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFullscreenMode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12224",
    "data-name": "Group 12224",
    transform: "translate(-1864 -186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12223",
    "data-name": "Group 12223",
    transform: "translate(1863.895 186.156)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2674",
    "data-name": "Ellipse 2674",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(0.105 -0.156)",
    fill: "#2179fe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "expand",
    transform: "translate(1870 192)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11884",
    "data-name": "Group 11884"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11883",
    "data-name": "Group 11883"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37932",
    "data-name": "Path 37932",
    d: "M282.417.417c0-.007,0-.013,0-.02s0-.016,0-.024,0-.015-.006-.023,0-.014-.005-.021-.005-.015-.008-.022l-.008-.021-.009-.02-.01-.021-.011-.019-.012-.02-.015-.02-.012-.016c-.01-.012-.02-.023-.03-.034h0q-.016-.016-.034-.03l-.017-.012-.02-.015-.02-.012-.019-.011-.021-.01-.02-.009-.021-.008L282.091.02,282.07.015l-.023-.006-.024,0L282,0l-.046,0h-3.236a.462.462,0,1,0,0,.925h2.12L277.469,4.3a.462.462,0,0,0,.654.654l3.372-3.371V3.7a.462.462,0,0,0,.925,0V.462C282.419.447,282.418.432,282.417.417Z",
    transform: "translate(-271.324)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37933",
    "data-name": "Path 37933",
    d: "M4.3,277.468.925,280.84v-2.12a.462.462,0,1,0-.925,0v3.236c0,.015,0,.03,0,.046s0,.013,0,.02,0,.016,0,.025,0,.015.006.023,0,.014.005.021.005.015.008.022l.008.021.009.02.01.021.011.019.012.02.015.02.012.017c.01.012.02.023.03.034h0l.034.03.016.012.02.015.02.012.019.011.021.01.02.009.021.008.022.008.021.005.023.006.024,0,.02,0,.046,0H3.7a.462.462,0,0,0,0-.925H1.578l3.372-3.371a.462.462,0,1,0-.654-.654Z",
    transform: "translate(0 -271.323)",
    fill: "#fff"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenMode);
export default __webpack_public_path__ + "static/media/fullscreen-mode.43bf755c.svg";
export { ForwardRef as ReactComponent };